export const PROFILE_TYPES = Object.freeze({
    AFFILIATE: 'affiliate',
    SPECIALIST: 'specialist',
    DEVELOPER: 'developer',
});

export const USER_CODE_STATUS = Object.freeze({
    INACTIVE: 'inactive',
    ANALYSIS: 'analysis',
    ACTIVE: 'active',
    REPROVED: 'reproved',
    SUSPENDED: 'suspended',
    UNREGISTRED: 'unregistred',
    REFUSED: 'refused',
});

export const APP_STATUS = Object.freeze({
    DEVELOPMENT: 'development',
    REVIEW: 'review',
    APPROVED: 'approved',
    REPROVED: 'reproved',
    PUBLISHED: 'published',
    DEPRECATED: 'deprecated',
    EXPIRED: 'expired',
});

export const APP_STEPS = Object.freeze({
    CONFIGURATION: 'configuration',
    MANAGE: 'manage',
    TEST: 'test',
    APPROVAL: 'approval',
    PUBLISH: 'publish',
});

export const CATEGORY_ID = Object.freeze({
    PAYMENTS: 7,
});
